import React from 'react';
import {Route, Redirect} from 'react-router';

import {UserIsAuthenticated, UserIsNotAuthenticated} from './utils/authHelpers';

import app from './modules/app';
import caresheets from './modules/caresheets';
import customer from './modules/customer';
import labels from './modules/labels';
import users from './modules/users';

export default (
  <Route component={app.components.App}>
    <Redirect from="/" to="/labels"/>
    <Route component={UserIsAuthenticated(app.components.NavLayout)}>
      <Route path="/articles" component={UserIsAuthenticated(labels.components.ArticlesPage)}/>
      <Route path="/ads" component={UserIsAuthenticated(caresheets.components.AdsPage)}/>
      <Route path="/caresheets" component={UserIsAuthenticated(caresheets.components.CareSheetsPage)}/>
      <Route path="/store" component={UserIsAuthenticated(caresheets.components.StoreInfoPage)}/>
      <Route path="/labels" component={UserIsAuthenticated(labels.components.LabelsPage)}/>
      <Route path="/no_access" component={UserIsAuthenticated(labels.components.NoAccessPage)}/>
      <Route path="/users" component={UserIsAuthenticated(users.components.UsersPage)}/>
      <Route path="/users/create" component={UserIsAuthenticated(users.components.CreateUserPage)}/>
      <Route path="/users/edit" component={UserIsAuthenticated(users.components.EditUserPage)}/>
    </Route>

    <Route path="/pet_search" component={UserIsAuthenticated(labels.components.PetSearchPage)}/>
    <Route path="/create_label" component={UserIsAuthenticated(labels.components.CreateLabelPage)}/>
    <Route path="/edit_label" component={UserIsAuthenticated(labels.components.EditLabelPage)}/>
    <Route path="/custom_label" component={UserIsAuthenticated(labels.components.CustomLabelPage)}/>
    <Route path="/customize_label" component={UserIsAuthenticated(labels.components.CustomizeLabelPage)}/>
    <Route path="/advanced_settings_label" component={UserIsAuthenticated(labels.components.AdvancedSettingsPage)}/>
    <Route path="/login" component={UserIsNotAuthenticated(customer.components.LoginPage)}/>
    <Route path="/forgot" component={UserIsNotAuthenticated(customer.components.ForgotPasswordPage)}/>    
    <Route path="*" component={UserIsAuthenticated(app.components.NotFoundPage)}/>
  </Route>
);


/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/